import * as React from 'react';
import { SVGProps } from 'react';

const IconFilePresentationSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M9 7V1a6 6 0 0 1 6 6H9Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 8.5H14a6.502 6.502 0 0 1-13 0A6.502 6.502 0 0 1 7.5 2v6.5Zm5.41 1A5.502 5.502 0 0 1 2 8.5c0-2.696 1.94-4.94 4.5-5.41V9.5h6.41Z"
    />
  </svg>
);
export default IconFilePresentationSizeS;
